export const environment = {
  production: true,
  useMock: false,
  graphqlEndpoint: 'https://trexa-stg-api.ivalley.my/graphql/',
  devAuthToken: '',
  /**
   * Auth is wired — a first-time visitor must NOT be auto-logged in. They browse the
   * public customer module as a guest; vendor/admin remain guarded and require login.
   * (Auto-bootstrap of a default persona is disabled by leaving this false.)
   */
  skipAuth: false,
  defaultPersona: 'vendor' as 'vendor' | 'admin' | 'customer',
  /** Chatvion (WhatsApp) whitelisted tenant used by the admin WhatsApp Device tab. */
  wasapBotTenantId: 'demo-tenant',
  /** Public origin for outbound links (WhatsApp document re-upload) — the staging site. */
  publicAppOrigin: 'https://trexa-stg.ivalley.my',
};
